<div class="wrapper__form container mt-5 mb-3 border__form">
  <h2 class="text-primary mb-4 text-center">
    {{ "visualizar-documentos.titulo" | translate }} {{ tramiteId }}
  </h2>

  <div *ngIf="documentos.length === 0" class="text-center">
    <p class="text-muted"> {{"visualizar-documentos.sin-documentos" | translate }} </p>
  </div>

  <div *ngFor="let doc of documentos" class="d-flex align-items-center mb-3">
    <img
      src="assets/img/PDF_file_icon.svg"
      alt="PDF"
      width="30"
      class="me-2"
      style="cursor: pointer"
      (click)="descargar(doc.url)"
    />
    <button
        type="button"
        class="text-decoration-none"
        (click)="descargar(doc.url)"
        [attr.aria-label]="'Descargar ' + doc.nombre">
        {{ doc.nombre }}
      </button>
  </div>
</div>
